const events = {
    drawPolygon: "drawPolygon",
    drawPolyline: "drawPolyline",
    draw:"draw",
    addMarkerToggle:"addMarkerToggle", // for toggling add marker modal.
    savePolygon:'savePolygon',
    addNewShape:'addNewShape',
    disableDraw:"disableDraw",
    resetDrawingMode:"resetDrawingMode",
    saveHeatData:'saveHeatData',
    uploadElevationData:'uploadElevationData',
    zoomMapToCoordinate:'zoomMapToCoordinate',
    deleteCourseMapElement:{
      courseMapVectorDelete:"courseMapVectorDelete",
      courseMapSimpleDataDelete:"courseMapSimpleDataDelete"
    },
    toggleMapLoadingScreen:"toggleMapLoadingScreen",
    openCourseInfoModal:"openCourseInfoModal",
    openScoreCardInfoModal:"openScoreCardInfoModal",
    openMapElementInfoModal:"openMapElementInfoModal",
    openMappingNotesModal:'openMappingNotesModal',
    triggerEditModeExternal:'triggerEditModeExternals',
    openMapLayerType : 'openMapLayerType',
    openTreeElementInModal:"openTreeElementInModal",
    openBunkerElementInModal:"openBunkerElementInModal",
    fitMapToHole: "fitMapToHole",
    autoGenerateBackground: "autoGenerateBackground",
    openImageOverlayPanel: "openImageOverlayPanel",
    openToolsMenu: "openToolsMenu",
    toolsMenuVisibility: "toolsMenuVisibility",
    openFullCourseShift: "openFullCourseShift",
    escapeFullCourseShift: "escapeFullCourseShift",
    // logoutCurrentUser: "logoutCurrentUser",
    // routerPush: "routerPush",
    // fetchAfterAddToFavourite:'fetchAfterAddToFavourite'
  };
  
  export default events;